export const getUTCDate = (timeInMs) => new Date(Date.now() + timeInMs).toUTCString();
//# sourceMappingURL=getUTCDate.js.map